import {CommonModule} from '@angular/common';
import {Component, computed, Input, input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {ActionLink, Link} from 'shared/pretty-easy-navigation/models';

@Component({
  selector: 'app-pretty-easy-link',
  standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive,
        TranslateModule,
        MatIcon,
        MatTooltipModule
    ],
  templateUrl: './pretty-easy-link.component.html'
})
export class PrettyEasyLinkComponent {
    @Input() isSidebarFolded: boolean;
    public linkData = input<Link | ActionLink>();
    private link = computed(() => this.linkData().link);
    public label = computed(() => this.linkData().label);
    public icon = computed(() => this.linkData().icon);
    public queryParams = computed(() => this.linkData().queryParams);
    public fragment = computed(() => this.linkData().fragment);
    public routerLink = computed(() => this.link()?.startsWith('/') ? this.linkData().link : undefined); // Ouais c'est pas terrible link.link
    public href = computed(() => this.link()?.startsWith('/') ? undefined : this.linkData().link);

    public formattedClasses = computed(() => {
        const classes = [
            'pretty-easy-link',
            ...this.linkData().classes || []
        ];

        if (false /*this.link().isActive*/) {
            classes.push('active');
        }

        return classes;
    })

    public onClick (event: MouseEvent): void {
        if (this.linkData().type === 'actionLink') {
            (<ActionLink>this.linkData()).action(event);
        }
    }

}

